import React from "react";
const NoBookings = () => {
  return (
    <div className="Errorloading">
        <br></br>
        <br></br>
      <h3>You currently have no bookings!</h3>
    </div>
  );
};

export default NoBookings;